import { useDynamicFeatureContext } from './context'

export const useFeatures = () => {
  return useDynamicFeatureContext('configuration')
}
